// create a generic angular service that will be overriden in the app module
// that will be used to get the current loggen in user, that can be used to get the
// current user, with their name, and if they are an admin or not
import { Observable, of } from 'rxjs';
import { ActorSource } from '@nuso/cpaas/types';

export interface CpaasPortalUser {
  id: number;
  // Which user directory `id` belongs to. This interface is implemented once per
  // host app precisely because they authenticate against different tables, and the
  // ids overlap — so an id must never be compared without it.
  source: ActorSource;
  name: string;
  isAdmin: boolean;
  isReseller: boolean;
}

export abstract class CpaasUserService {
  public abstract currentCpaasPortalUser(): Observable<CpaasPortalUser | null>;
}
